import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-header-phone',
  templateUrl: './icon-header-phone.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconHeaderPhoneComponent {}
